import { Component, forwardRef, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { IBarighet } from "~app/features/planera/model/IBarighet";
import { ArbetsorderSearchBase } from "../../../models/arbetsorder-search-base";
import { ArbetsorderSearchTexts } from "../../../models/arbetsorder-search-texts";

@Component({
    selector: "rask-arbetsorder-search-skoglig-data-tillganglighet",
    templateUrl: "./arbetsorder-search-skoglig-data-tillganglighet.component.html",
    styleUrls: ["./arbetsorder-search-skoglig-data-tillganglighet.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBase,
            useExisting: forwardRef(() => ArbetsorderSearchSkogligDataTillganglighetComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CheckboxComponent,
        FormsModule,
        RadiobuttonGroupComponent
    ]
})
export class ArbetsorderSearchSkogligDataTillganglighetComponent extends ArbetsorderSearchBase {
    texts = ArbetsorderSearchTexts.texts;

    radioButtonsArbetsorderAtgard = {
        entity: [
            { key: 1,
                value: this.texts.arbetsorder },
            { key: 0,
                value: this.texts.atgarder }
        ] as IRadiobuttonItem[],

        or_and: [
            { key: 0,
                value: this.texts.barighetAnd },
            { key: 1,
                value: this.texts.barighetOr }
        ] as IRadiobuttonItem[]
    };

    constructor() {
        super();
    }

    forceUpdateFilterChange(): void {
        // ska vara tom
    }

    changeArrayValue(array: number[], barighet: IBarighet, checked: boolean) {
        if (!checked && array.includes(barighet.key)) {
            array.splice(array.indexOf(barighet.key), 1);
        } else if (checked && !array.includes(barighet.key)) {
            array.push(barighet.key);
        }

        this.searchFilter.skogligdata.tillganglighet.orSearch = this.setSearchOnOrAnd();
    }

    hasValue(array: number[], barighet: IBarighet) {
        return array?.includes(barighet.key);
    }

    setSearchOnOrAnd(): boolean {
        if (this.searchFilter.skogligdata.tillganglighet.terrang.length > 0
            && this.searchFilter.skogligdata.tillganglighet.vag.length > 0
            && this.searchFilter.skogligdata.tillganglighet.orSearch === undefined) {
            return false;
        } else if (this.searchFilter.skogligdata.tillganglighet.terrang.length === 0
            || this.searchFilter.skogligdata.tillganglighet.vag.length === 0) {
            return undefined;
        }
        return this.searchFilter.skogligdata.tillganglighet.orSearch;
    }

    setOrAndValue(value: number) {
        if (value === undefined) {
            delete this.searchFilter.skogligdata.tillganglighet.orSearch;
        } else if (value === 1) {
            this.searchFilter.skogligdata.tillganglighet.orSearch = true;
        } else if (value === 0) {
            this.searchFilter.skogligdata.tillganglighet.orSearch = false;
        } else {
            delete this.searchFilter.skogligdata.tillganglighet.orSearch;
        }
    }

    getOrAndValue() {
        if (this.searchFilter.skogligdata.tillganglighet.orSearch === undefined) {
            return null;
        } else if (this.searchFilter.skogligdata.tillganglighet.orSearch === true) {
            return 1;
        }
        return 0;
    }
}
